var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVeryGood = function SvgVeryGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.95 0a5.9 5.9 0 0 1 5.658 4.231 8 8 0 0 1 10.176 10.113 5.902 5.902 0 0 1 0 11.31 8 8 0 0 1-10.13 10.13 5.901 5.901 0 0 1-11.31 0 8 8 0 0 1-10.13-10.13 5.902 5.902 0 0 1 0-11.31A8 8 0 0 1 14.299 4.2 5.9 5.9 0 0 1 19.95 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.869,
    cy: 17.183,
    r: 1.667,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.16,
    cy: 17.183,
    r: 1.667,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.37,
    d: "M19.999 21.371a3.111 3.111 0 0 1-6.223 0M26.223 21.371a3.111 3.111 0 0 1-6.222 0"
  })));
};
export default SvgVeryGood;